module.exports = "/_next/static/images/powered-by-google-on-white-hdpi-6a4bf63cbe5fd8f53248363f88b995fd.png.webp";